module.exports = __webpack_public_path__ + "static/media/brand-loader-final.566ef94e.gif";